import { Toaster as Sonner } from 'sonner';

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="top-right"
      toastOptions={{
        classNames: {
          toast: 'group toast group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-gray-700',
          actionButton: 'group-[.toast]:bg-gray-900 group-[.toast]:text-gray-50',
          cancelButton: 'group-[.toast]:bg-gray-100 group-[.toast]:text-gray-700',
          error: 'group-[.toaster]:!bg-red-100 group-[.toaster]:!text-gray-900 [&>svg]:!text-red-500',
          success: 'group-[.toaster]:!bg-green-100 group-[.toaster]:!text-gray-900 [&>svg]:!text-green-500',
          warning: 'group-[.toaster]:!bg-yellow-100 group-[.toaster]:!text-gray-900 [&>svg]:!text-yellow-500',
          info: 'group-[.toaster]:!bg-blue-100 group-[.toaster]:!text-gray-900 [&>svg]:!text-blue-500',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
